// extracted by mini-css-extract-plugin
export var animLottie = "sceneLoading-module--animLottie--8M9ar";
export var text = "sceneLoading-module--text--2AC4Q";
export var sceneBg = "sceneLoading-module--sceneBg--yCP9f";